import { ApolloClient, InMemoryCache } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { onError } from "@apollo/client/link/error";

const errorLink = onError(({ networkError }) => {
  if (!networkError) return;

  if (
    "statusCode" in networkError &&
    [401, 403].includes(networkError.statusCode) &&
    networkError.statusCode !== 502
  ) {
    window.location.href = `${process.env.REACT_APP_ME_BOOKING_URL}/login`;
  }
});

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_ME_BOOKING_URL + "/graphql/default",
  credentials: "include",
});

export const apolloClient = new ApolloClient({
  link: errorLink.concat(uploadLink),
  cache: new InMemoryCache(),
});
